// PLACEHOLDER that does not implement localization ; props to localize: label
import { SelectOption } from '@amzn/meridian/select';
import { Logger } from '../../../utils/logger';

Logger.warn('We are still working on localizing SelectOption. This placeholder file re-exports Meridian component.');
export default SelectOption;
